interface AvatarUser {
  avatar?: string | null;
  avatarVersion?: string | number | null;
}

/**
 * Arma la URL de la foto de perfil que expone el proveedor de autenticación.
 *
 * Firebase suele reutilizar la misma URL cuando el usuario cambia la foto en su
 * cuenta, así que `FirebaseContext` sella una versión cada vez que detecta una
 * foto distinta y acá se agrega a la URL. Sin eso el navegador seguiría
 * mostrando la imagen vieja desde la caché.
 *
 * Devuelve null cuando no hay foto, que es la señal para caer a las iniciales.
 */
export function getAvatarSrc(user: AvatarUser | null | undefined): string | null {
  if (!user?.avatar) return null;
  if (!user.avatarVersion) return user.avatar;
  return `${user.avatar}${user.avatar.includes('?') ? '&' : '?'}v=${user.avatarVersion}`;
}
